import PropTypes from 'prop-types'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import { useContext, useEffect, useState } from 'react'
import { getRequest, postRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'
import { ConnectorContext } from '../context/context'
import Button from '../../../common/Button'
import CheckBox from '../../../common/CheckBox'
import { NavContext } from '../../../../context/global_context'
import NoRecordsFound from '../../../common/NoRecordsFound'

const DuplicatePartNumber = (props) => {
  const { vehicle } = useParams()
  const [state, dispatch] = useContext(NavContext)
  const [connectorState, connectorDispatch] = useContext(ConnectorContext)
  const [connectosData, setConnectosData] = useState([])
  const [selectedConnector, setSelectedConnector] = useState(null)

  useEffect(() => {
    if (props.showDuplicatePartNumberModal) {
      getConnectorsForPartNumber()
    }
  }, [props.showDuplicatePartNumberModal])

  const getConnectorsForPartNumber = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Part Number Data',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/connector/part_number/search/?vehicle=${vehicle}&part_number=${connectorState.selectedConnector?.fpn}&connector=${connectorState.selectedConnector?.name}`
    )
    setConnectosData(res.data)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const saveCloneSvg = async () => {
    if (!selectedConnector?.name) {
      window.alert('Please Select Connector')
      return
    }
    if (
      window.confirm(
        `Are you sure want to clone svg of selected ${selectedConnector.name}, It will delete existing svg if exists !`
      ) == true
    ) {
      dispatch({
        type: 'loader',
        data: {
          caption: `Cloning SVG File From ${selectedConnector.name}`,
          showLoader: true,
        },
        notification: {},
      })

      let res = await postRequest(
        `/api/connector/clone/svg/?vehicle=${vehicle}`,
        {
          destination_connector: connectorState.selectedConnector?.id,
          source_connector: selectedConnector?.id,
        }
      )
      if (res?.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: `SVG File Successfully Cloned`,
          },
        })
      } else {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    }
  }
  return (
    <Modal
      onClose={() => {
        props.setShowDuplicatePartNumberModal(false)
      }}
      show={props.showDuplicatePartNumberModal}
      size={`w-3/4`}
    >
      <ModalHeader className={'text-white'}>
        Clone SVG for{' '}
        <span className="underline">
          {connectorState.selectedConnector?.name}
        </span>{' '}
        and{' '}
        <span className="underline">
          {connectorState.selectedConnector?.fpn}
        </span>{' '}
        part number
      </ModalHeader>
      <ModalBody>
        <div className="font-light">
          <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
            <div className="flex w-1/12 pl-0"></div>
            <div className="flex w-4/12 pl-2 items-center">Name</div>
            <div className="flex w-3/12 pl-2 items-center">Part Number</div>
            <div className="flex w-4/12 pl-2 items-center">Vehicle</div>
          </div>
        </div>
        <div style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
          {connectosData?.length < 1 && <NoRecordsFound />}
          {connectosData?.map((connectorObj, connectorIdx) => {
            return (
              <div
                key={`connector-${connectorIdx}`}
                className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black"
              >
                <div className="flex flex-row w-full">
                  <div className="flex w-1/12 pl-0 items-center cm-link text-blue-800 justify-center">
                    <div>
                      <span
                        onClick={() => {
                          // props.onPartNumberSelect()
                        }}
                        className="cursor-pointer p-1"
                      >
                        <CheckBox
                          checked={
                            connectorObj?.id == selectedConnector?.id
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            if (!e.target.checked) {
                              setSelectedConnector(null)
                            } else {
                              setSelectedConnector(connectorObj)
                            }
                          }}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="flex w-4/12 pl-2 items-center">
                    {connectorObj.name}
                  </div>
                  <div className="flex w-3/12 pl-2 items-center">
                    {connectorObj.fpn}
                  </div>
                  <div className="flex w-4/12 pl-2 items-center">
                    {connectorObj.vehicle_name}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        {selectedConnector?.name && (
          <div className="flex justify-end">
            <div className="mr-2">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 mb-0 w-auto justify-end`}
                onClick={(e) => {
                  saveCloneSvg()
                }}
                value={'text'}
                text={'Clone Selected SVG'}
              />
            </div>
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

DuplicatePartNumber.propTypes = {
  setShowDuplicatePartNumberModal: PropTypes.func.isRequired,
  showDuplicatePartNumberModal: PropTypes.bool.isRequired,
}

export default DuplicatePartNumber
